import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import GenerateForm from '../../components/Form/GenerateForm'
import { addManyElementsData, addNewForm, updateFormMessage } from '../../components/Form/formsSlice'
import DynamicForm, { IRequiredField } from '../../components/Form/DynamicForm'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import FormActionButtonsSection from '../../components/Form/FormActionButtonsSection'
import { Button } from '@mui/material'
import { AdminPagesService } from '../admin/adminPagesSlice'
import { LoadingButton } from '@mui/lab'
import { IAxiosDefaultDataObject } from '../../config'
import LocationsApp, { emptyLocatiomModel, ILocationModel } from './LocationsApp'
import { title } from 'process'
import { useNavigate } from 'react-router-dom'
import { ICreateOrUpdatePageProps } from '../admin/Interfaces'
import NotFound from '../../components/NotFound'
import { updateLocation } from './locationsSlice'

export default function CreateOrUpdateLocation(props: ICreateOrUpdatePageProps) {

    const { isUpdate, itemId } = props

    const [locationDetails, setLocationDetails] = useState<ILocationModel>(emptyLocatiomModel)
    const [notFound, setNotFound] = useState<boolean>(false)

    const navigate = useNavigate()

    const locationsApp = new LocationsApp()

    const elemPrefix: string = "location_form_"
    const formName: string = "create-or-update-location"

    const elementsData = DynamicForm.useReturnAllFormsData()

    const dispatch = useDispatch()
    const currentPage = AdminPagesService.usePageDetails("locations")
    const currentForm = DynamicForm.useReturnSingleForm(formName)
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(elemPrefix + name, elementsData).value

    /**
     * Update elements data
     */
    const updateElementsData = (title: string, country: string, address: string, latitude: number, longitude: number, thumbnail: string) => dispatch(addManyElementsData([
        {
            name: elemPrefix + "title",
            value: title,
        },
        {
            name: elemPrefix + "country",
            value: country,
        },
        {
            name: elemPrefix + "address",
            value: address,
        },
        {
            name: elemPrefix + "latitude",
            value: latitude,
        },
        {
            name: elemPrefix + "longitude",
            value: longitude,
        },
        {
            name: elemPrefix + "thumbnail",
            value: thumbnail,
        }
    ]))

    /**
     * Reset form
     */
    const resetForm = () => {
        updateElementsData("", "", "", 0, 0, "")
        DynamicForm.createOrUpdateFormMessage(formName, { shown: false, type: "success", message: "" }, dispatch)
    }

    /**
     * Load location
     */
    const loadLocation = () => {

        DynamicForm.updateFormLoadingStatus(formName, true, dispatch)
        locationsApp.singleInstanceDetails(itemId ? itemId : 0)
            .then(response => {

                console.log(response)
                
                const loadedLocation: ILocationModel = response.data
                setLocationDetails(loadedLocation)
                updateElementsData(loadedLocation.title, loadedLocation.country, loadedLocation.address, loadedLocation.latitude, loadedLocation.longitude, loadedLocation.thumbnail)

                setNotFound(false)
                DynamicForm.updateFormLoadingStatus(formName, false, dispatch)

            })
            .catch(error => {
                console.log(error)
                const message = error.response.data.message ? error.response.data.message : "Fatal Error"

                switch(error.response.status){

                    case 404:
                        setNotFound(true)

                }

                DynamicForm.updateFormLoadingStatus(formName, false, dispatch)
            })
    }
    

    /**
     * Handle submit
     */
    const handleSubmit = () => {


        let data: IAxiosDefaultDataObject = {
            title: singleElemDataValue("title"),
            country: singleElemDataValue("country"),
            address: singleElemDataValue("address"),
            latitude: singleElemDataValue("latitude"),
            longitude: singleElemDataValue("longitude"),
            thumbnail: singleElemDataValue("thumbnail"),
            maps_link: singleElemDataValue("maps_link")
        }

        let requiredFields: Array<IRequiredField> = [
            {
                id: elemPrefix + "title",
                message: "Title is required!"
            },
            {
                id: elemPrefix + "country",
                message: "Country is required!"
            },
            {
                id: elemPrefix + "address",
                message: "Address is required!"
            },
            // {
            //     id: elemPrefix + "longitude",
            //     message: "Longitude is required!"
            // }
        ]

        if (isUpdate){
            data.id = itemId
            data.update = true
        }

        DynamicForm.resetRequiredFieldsHelperText(requiredFields, elementsData, dispatch)
        const verifyForm = DynamicForm.verifyForm(elementsData, requiredFields)


        if (verifyForm.isValid){
            DynamicForm.updateFormLoadingStatus(formName, true, dispatch)

            locationsApp.createNewInstance(data)
                .then(response => {

                    const { data } = response
                    const message = data.message ? data.message : "Success!"

                    DynamicForm.updateFormLoadingStatus(formName, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(formName, { shown: true, type: "success", message: message }, dispatch)

                    dispatch(updateLocation(data))
                    resetForm()
                    navigate(`/panel/${currentPage.name}`)

                })
                .catch(error => {

                    console.log(error)
                    const message = error.response.data.message ? error.response.data.message : "Fatal Error"

                    DynamicForm.updateFormLoadingStatus(formName, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(formName, { shown: true, type: "error", message: message }, dispatch)

                })
        }else{
            DynamicForm.updateRequiredFieldsHelperText(verifyForm.fields, elementsData, dispatch)
        }


    }

    /**
     * Create Form
     */
    useEffect(() => {

        dispatch(addNewForm({
            name: formName,
            elements: [
                {
                    id: elemPrefix + "title",
                    xs: 8,
                    type: "TextField",
                    label: "Title",
                    fullWidth: true
                },
                {
                    id: elemPrefix + "country",
                    xs: 4,
                    type: "SelectCountry",
                    label: "Country",
                    fullWidth: true,
                },
                {
                    id: elemPrefix + "address",
                    xs: 12,
                    type: "TextField",
                    label: "Address",
                    fullWidth: true,
                    multiline: true,
                    minRows: 4,
                    maxRows: 4,
                },
                {
                    id: elemPrefix + "maps_link",
                    xs: 12,
                    type: "GoogleMap",
                    label: "Google Maps Link",
                    fullWidth: true,
                },
                // {
                //     id: elemPrefix + "latitude",
                //     xs: 6,
                //     type: "TextField",
                //     fieldType: "number",
                //     label: "Latitude",
                //     fullWidth: true
                // },
                // {
                //     id: elemPrefix + "longitude",
                //     xs: 6,
                //     type: "TextField",
                //     fieldType: "number",
                //     label: "Longitude",
                //     fullWidth: true
                // },
                {
                    id: elemPrefix + "thumbnail",
                    xs: 12,
                    type: "ImageUploader",
                    label: "Thumbnail",
                    fullWidth: true
                },
            ]
        }))

        updateElementsData("", "", "", 0, 0, "")

    }, [])

    /**
     * Load location
     */
    useEffect(() => {
        if (isUpdate && itemId){
            loadLocation()
        }else{
            resetForm()
        }
    }, [itemId, isUpdate])

    return(
        <>
            <SectionBoxContainer
                showTitle={true}
                title="Details"
                description="Title, address, country, etc."
            >
                {notFound ? <NotFound /> : <GenerateForm name={formName} />}

            </SectionBoxContainer>

            <FormActionButtonsSection>
                <LoadingButton disabled={notFound} loading={currentForm.loading} className="general-button submit-style" variant="contained" onClick={() => handleSubmit()} >{isUpdate ? currentPage.messages.editShort : currentPage.messages.createShort}</LoadingButton>
            </FormActionButtonsSection>
        </>
    )
}